import {
  CreditCard,
  Landmark,
  LaptopMinimalCheck,
  UserCheck,
} from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Stepper, useStepper } from "@/components/ui/stepper";

type Props = {
  currentStep?: number;
};

export const PaymentStepper = ({ currentStep: _currentStep }: Props) => {
  const { t } = useTranslation();
  const { currentStep } = useStepper();

  const steps = useMemo(() => {
    const steps = [
      {
        title: t("payment_steps.step_1.title"),
        description: t("payment_steps.step_1.description"),
        icon: CreditCard,
      },
      {
        title: t("payment_steps.step_2.title"),
        description: t("payment_steps.step_2.description"),
        icon: Landmark,
      },
      {
        title: t("payment_steps.step_3.title"),
        description: t("payment_steps.step_3.description"),
        icon: UserCheck,
      },
      {
        title: t("payment_steps.step_4.title"),
        description: t("payment_steps.step_4.description"),
        icon: LaptopMinimalCheck,
      },
    ];

    return steps;
  }, [t]);

  return <Stepper steps={steps} currentStep={_currentStep ?? currentStep} />;
};
